import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        transfersOUT: [],
        lastConfirmedTransferOut: null,
    },
    getters: {

    },
    mutations: {
        /*
        setSNTransferOUT(state,d) {
            if (state.transferOUT.length) {
                let fnd = state.transferOUT.findIndex( m => { return m.snID === d.snID; });
                if (fnd !== -1) {
                    state.transferOUT.splice(fnd,1);
                }
            }
            state.transferOUT.push(d);
        },
        setLastTransferOut(state,d) {
            state.lastConfirmedTransferOut = d;
            state.transferOUT = [];
        },
        clearAllTransferConfirms(state) {
            state.lastConfirmedTransferOut = null;
        },
        */
        setTransfersOUT(state, d) {
            console.log(d);
        }
    },
    actions: {
        getTransfers(context, d) {
            console.log('!');
            axios.get('/getTransfersOUT')
                .then(response => {
                    if (response.data) {
                        context.commit('setTransfersOUT', response.data);
                    }
                });
        },
        checkSNforTrfOUT(context, d) {
            if (d.sn) {
                axios.post('/checkSNforTrfOUT', d)
                    .then(response => {
                        if (response.data) {
                            if (response.data.error) {
                                context.commit('showMessage', response.data.error);
                                if (response.data.error.sound) {
                                    let audio = new Audio('./mp3/' + response.data.error.sound);
                                    audio.play();
                                }
                            }
                            if (response.data.sn) {
                                if (response.data.sound) {
                                    let audio = new Audio('./mp3/' + response.data.sound);
                                    audio.play();
                                }
                                context.commit('setSNTransferOUT', response.data);
                            }
                        }
                    });
            }
        },
        makeTransferOUT(context, d) {
            if (d) {
                axios.post('/makeTrfOUT', d)
                    .then(response => {
                        if (response.data) {
                            if (response.data.successCNT) {
                                if (response.data.sound) {
                                    let audio = new Audio('./mp3/' + response.data.sound);
                                    audio.play();
                                }
                                // alespon 1 se pridalo
                                context.commit('setLastTransferOut', response.data);
                            }
                        }
                    });
            }
        },

    },
};
